import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { throwError } from 'rxjs';
import { SNACK_BAR_VARIANTS } from './types';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SnackBarComponent } from '../../../shared/components/snack-bar/snack-bar.component';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  constructor(
    private snackBar: MatSnackBar,
    private zone: NgZone,
    private sanitizer: DomSanitizer,
  ) {}

  private getSanitizedMessage(
    message: string,
    variant: keyof typeof SNACK_BAR_VARIANTS,
  ): SafeHtml {
    const config = SNACK_BAR_VARIANTS[variant] || SNACK_BAR_VARIANTS['info'];
    const fullMessage = `${message}`;
    return this.sanitizer.bypassSecurityTrustHtml(fullMessage);
  }

  close(): void {
    this.snackBar.dismiss();
  }

  open(
    message: string,
    variant: keyof typeof SNACK_BAR_VARIANTS = 'info',
    actionIconPath = '',
    duration?: number,
    actionClick: () => void = () => {},
    // confi1g?: any,
  ): void {
    const sanitizedMessage = this.getSanitizedMessage(message, variant);
    const icon = SNACK_BAR_VARIANTS[variant].iconPath;
    const config: MatSnackBarConfig = {
      duration: duration || SNACK_BAR_VARIANTS[variant].duration,
      panelClass: SNACK_BAR_VARIANTS[variant].panelClass,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      data: {
        message: sanitizedMessage as string,
        iconPath: icon,
        actionIconPath,
        actionClick: () => {
          actionClick(); // Call the passed action
          this.snackBar.dismiss(); // Close the snackbar
        },
      },
    };
    if (config) {
      this.zone.run(() => {
        this.snackBar.openFromComponent(SnackBarComponent, config);
      });
    }
  }

  success(
    message: string,
    actionIconPath = 'assets/close-white.svg',
    duration?: number,
    actionClick: () => void = () => {},
  ): void {
    this.open(message, 'success', actionIconPath, duration, actionClick);
  }

  warning(
    message: string,
    actionIconPath = 'assets/close-black.svg',
    duration?: number,
    actionClick: () => void = () => {},
  ): void {
    this.open(message, 'warning', actionIconPath, duration, actionClick);
  }

  danger(
    message: string,
    actionIconPath = 'assets/close-white.svg',
    duration?: number,
    actionClick: () => void = () => {},
  ): void {
    this.open(message, 'danger', actionIconPath, duration, actionClick);
  }

  info(
    message: string,
    actionIconPath = 'assets/close-white.svg',
    duration?: number,
    actionClick: () => void = () => {},
  ): void {
    this.open(message, 'info', actionIconPath, duration, actionClick);
  }

  handleError(
    error: HttpErrorResponse | any,
    actionIconPath = 'assets/close-white.svg',
    duration = 3000,
    actionClick: () => void = () => {},
  ) {
    let errorMessage = 'An error occurred';
    if (error instanceof HttpErrorResponse) {
      errorMessage = `Backend returned code ${error.status}: ${error.message}`;
    } else {
      errorMessage = error || error.message;
    }
    this.danger(errorMessage, actionIconPath, duration, actionClick);
    return throwError(() => error);
  }
}
